
import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

function RatesByHdbDropDown(props) {
  const { label, options, handleProServiceArray, subOptionData } = props;
  const { selectedProfServiceArray } = useSelector((state) => state.createOrderSlice)

  let value = selectedProfServiceArray?.filter(item => subOptionData?._id === item?.serviceId)[0]?.priceDetails?.hdbOptions
  return (
    <React.Fragment>


      <Form.Select value={value ?? ''} className="NoDefault" aria-label="select example" onChange={(e) => handleProServiceArray(options?.filter(item => item?.hdbOptions === e.target.value)[0], subOptionData)}>
        <option>Select size of property</option>
        {options.map((item) => {
          return <option value={item.hdbOptions}>{item.hdbOptions}</option>;
        })}
      </Form.Select>
    </React.Fragment>
  );
}

export default RatesByHdbDropDown;